<template>
  <button
    type="button"
    class="toggle-switch"
    :class="{'toggle-switch--on': on}"
    :title="title"
    :disabled="disabled"
    @click="$emit('toggle')"
  >
    <span class="toggle-switch__track" aria-hidden="true">
      <span class="toggle-switch__thumb" />
    </span>
    <span class="toggle-switch__label">{{ on ? yesLabel : noLabel }}</span>
  </button>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'ApiKeyToggleSwitch',
  props: {
    on: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    title: {type: String, default: null},
    yesLabel: {type: String, default: 'Oui'},
    noLabel: {type: String, default: 'Non'},
  },
  emits: ['toggle'],
});
</script>

<style lang="scss" scoped>
.toggle-switch {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  user-select: none;
}

.toggle-switch:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.toggle-switch__track {
  position: relative;
  flex-shrink: 0;
  width: 2.5rem;
  height: 1.35rem;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.85);
  transition: background 0.2s ease;
}

.toggle-switch__thumb {
  position: absolute;
  top: 0.17rem;
  left: 0.2rem;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.2);
  transition: transform 0.2s ease;
}

.toggle-switch--on .toggle-switch__track {
  background: #059669;
}

.toggle-switch--on .toggle-switch__thumb {
  transform: translateX(1.1rem);
}

.toggle-switch__label {
  min-width: 1.85rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(100, 116, 139, 1);
}

.toggle-switch--on .toggle-switch__label {
  color: #047857;
}
</style>
